"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  id: 'default',
  title: 'Reports',
  description: 'Click on the green pencil to edit or remove me.',
  userRole: '',
  primaryColor: '#75a1bd',
  secondaryColor: '#eaf2f8',
  containers: [{
    id: 'container',
    title: 'Report Group',
    description: 'Report group description.',
    tiles: []
  }]
};